const TAB_CHANGE = 'enquire-tab-change';
const screens = ['speak-to-us', 'visit-us', 'memberships', 'join-us']

export const navLinkListener = window.onload = () => {
    const navLinks = document.querySelectorAll('[data-cta-screen]');
    const enquireMenu = document.getElementById('enquire');

    for (const link of navLinks) {
        link.onclick = () => {
            const screen = link.getAttribute('data-cta-screen');
            
            if (!screen) return;
            //if (!screens.findIndex(s => s == screen) != -1) return new Error('Invalid screen type');

            enquireMenu.classList.add('enquire--toggled');

            const event = new CustomEvent(TAB_CHANGE, { detail: { tab: screens.findIndex(s => s == screen), goBack: false } });

            window.dispatchEvent(event);

            const enquireClose = enquireMenu.getElementsByClassName('enquire-close');

            for (const close of enquireClose) {
                close.onclick = () => enquireMenu.classList.remove('enquire--toggled');
            }
        }
    }
}


document.addEventListener('readystatechange', () => {
    navLinkListener();
});

